import { Box } from "@mui/material";
import { CustomDrawer, FormFooter, FormTextField } from "@shared/components";
import { Form, Formik } from "formik";
import { useMemo } from "react";
import {
  PartnerChannelFormFields,
  PartnerChannelFormInitialValues,
  PartnerChannelValidationSchema,
} from "../utils/constants";
import {
  AddUpdatePartnerChannelFormProps,
  PartnerChannelsFormValues,
} from "../utils/types";

const PartnerChannelForm = ({
  open,
  onClose,
  title,
  showCloseButton,
  initialValues,
  onSubmit,
  disable,
}: AddUpdatePartnerChannelFormProps) => {
  const mergedInitialValues = useMemo(
    () => ({
      ...PartnerChannelFormInitialValues,
      ...initialValues,
    }),
    [initialValues]
  );

  return (
    <CustomDrawer
      open={open}
      onClose={onClose}
      title={title}
      showCloseButton={showCloseButton}
    >
      <Formik
        enableReinitialize
        initialValues={mergedInitialValues}
        validationSchema={PartnerChannelValidationSchema}
        onSubmit={onSubmit}
      >
        {(formikProps) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              overflow: "hidden",
              paddingBottom: "80px",
            }}
          >
            <Box
              sx={{
                position: "relative",
                p: 2,
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                overflowX: "hidden",
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              {PartnerChannelFormFields.map(({ name, label, type }) => {
                return (
                  <FormTextField
                    key={name}
                    type={type}
                    name={name}
                    label={label}
                    value={String(
                      formikProps.values[
                        name as keyof PartnerChannelsFormValues
                      ]
                    )}
                    onChange={formikProps.handleChange}
                    touched={formikProps.touched as Record<string, unknown>}
                    errors={formikProps.errors as Record<string, unknown>}
                  />
                );
              })}
            </Box>
            <FormFooter
              disable={disable || !formikProps.dirty}
              isSubmitting={formikProps.isSubmitting}
            />
          </Form>
        )}
      </Formik>
    </CustomDrawer>
  );
};

export default PartnerChannelForm;
